import * as tslib_1 from "tslib";
import { MdArrowDropDown } from 'react-icons/md';
import React from 'react';
import { SimpleIcon } from 'sinoui-components/Icon';
import MenuList from 'sinoui-components/Menu/MenuList';
import MenuListItem from 'sinoui-components/Menu/MenuListItem';
import EditableSelectPopLayout from './EditableSelectPopLayout';
import SelectableContainer from '../containers/SelectableContainer';
/**
 * 可编辑选择框
 */
var EditableSelect = /** @class */ (function (_super) {
    tslib_1.__extends(EditableSelect, _super);
    function EditableSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPop = _this.renderPop.bind(_this);
        return _this;
    }
    // tslint:disable-next-line:no-any
    EditableSelect.prototype.renderPop = function (popProps) {
        var _this = this;
        return (React.createElement(EditableSelectPopLayout, null,
            React.createElement(MenuList, null, React.Children.map(this.props.children, function (child) {
                if (React.isValidElement(child)) {
                    // tslint:disable-next-line:no-any
                    var _a = child.props, value_1 = _a.value, children = _a.children;
                    return (React.createElement(MenuListItem, { key: value_1, value: value_1, onClick: function (event) {
                            event.stopPropagation();
                            popProps.onChange(event, value_1);
                            popProps.close();
                        }, selected: _this.props.value === value_1 }, children));
                }
                return child;
            }))));
    };
    EditableSelect.prototype.render = function () {
        return (React.createElement(SelectableContainer, tslib_1.__assign({}, this.props, { editable: true, baseClassName: "sinoui-editable-select", popRender: this.renderPop, icon: React.createElement(SimpleIcon, null,
                React.createElement(MdArrowDropDown, null)) })));
    };
    EditableSelect.defaultProps = {
        autoRePos: false,
        usePopModal: false,
    };
    return EditableSelect;
}(React.PureComponent));
export default EditableSelect;
//# sourceMappingURL=EditableSelect.js.map